export default __webpack_public_path__ + "static/media/error.54409253.svg";